export default __webpack_public_path__ + "static/media/vnt_home.e9dfeeef.jpg";